<template>
  <div id="sections-defences-armor-class-details-fifth-edition">
    <div class="content" v-show="toggleState" style="clear:left;">
      <h4 class="header-bar">Armor Details</h4>
      <div class="row">
        <div class="col-2 text-center">
          <under-input v-model.number="armorClass.armor.bonus" maxlength="2">
            Bonus
          </under-input>
        </div>
        <div class="col">
          <under-input v-model.trim="armorClass.armor.description">
            Armor
          </under-input>
        </div>
        <div class="col-2 text-center">
          <under-checkbox v-model="armorClass.armor.medium">
            <div class="d-sm-none d-md-block">Medium</div>
            <div class="d-md-none">Med</div>
          </under-checkbox>
        </div>
        <div class="col-2 text-center">
          <under-checkbox v-model="armorClass.armor.heavy">
            <div class="d-sm-none d-md-block">Heavy</div>
            <div class="d-md-none">Hvy</div>
          </under-checkbox>
        </div>
      </div>
      <armor-detail :armorClass="armorClass.shield">Shield</armor-detail>
      <armor-detail :armorClass="armorClass.magic">Magic</armor-detail>
      <armor-detail :armorClass="armorClass.misc">Miscellaneous</armor-detail>
    </div>

  </div>
</template>
<script>
import { mapState } from "vuex";
import ArmorDetail from "./_ArmorDetail.vue";
import UnderCheckbox from "../../shared/_UnderCheckbox.vue";
import UnderInput from "../../shared/_UnderInput.vue";

export default {
  name: "sections-defenses-details-fifth-edition",
  components: {
    ArmorDetail,
    UnderCheckbox,
    UnderInput
  },
  props: ["toggleState"],
  computed: mapState({
    armorClass: state => state.characters.current.defense.armorClass
  })
};
</script>
